import { supabase } from './supabaseClient'

interface OrderDetails {
  created_at: string
  total_price: number
  status: string
  racket_brand: string
  racket_description?: string
  tension_vertical?: number
  tension_horizontal?: number
  pickup_address?: string
  delivery_address?: string
  pickup_distance_km?: number
  delivery_distance_km?: number
  pickup_price?: number
  delivery_price?: number
  service_name?: string
  service_base_price?: number
  pickup_mode_label?: string
  delivery_mode_label?: string
  options?: Array<{ label: string; price_delta: number }>
  // Coupon
  coupon_code?: string
  original_service_price?: number
  discount_amount?: number
}

interface CustomerDetails {
  full_name?: string
  email?: string
  phone?: string
  address_line1?: string
  postal_code?: string
  city?: string
}

interface BookingEmailPayload {
  orderId: string
  orderDetails: OrderDetails
  customerDetails: CustomerDetails
  // Permet de désactiver l'envoi (tests) tout en gardant l'appel
  sendEnabled?: boolean
}

/**
 * Envoie un email de notification lors d'une nouvelle réservation
 * @param payload Les détails de la commande et du client
 * @returns Promise<boolean> true si l'email a été envoyé avec succès
 */
export async function sendBookingNotificationEmail(
  payload: BookingEmailPayload
): Promise<boolean> {
  try {
    // Flag côté frontend (true par défaut, false en tests via .env.test)
    const enabledEnv = (import.meta.env.VITE_BOOKING_EMAILS_ENABLED ?? 'true') as string
    const sendEnabled = enabledEnv.toLowerCase() !== 'false'

    const { data, error } = await supabase.functions.invoke('send-booking-email', {
      body: { ...payload, sendEnabled }
    })

    if (error) {
      console.error('Erreur lors de l\'envoi de l\'email de notification:', error)
      return false
    }

    console.log('Email de notification envoyé avec succès:', data)
    return true
  } catch (err) {
    console.error('Exception lors de l\'envoi de l\'email:', err)
    return false
  }
}
